<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<div class="settings-page-title" data-cy="business-settings-title">Versions management</div>

<app-table (selectedLine)="loadDataTree($event)"
  [accordionLineTemplate]="accordionLineTemplate"
  [disableAccordion]="$safeNavigationMigration(state?.disableAccordion)"
  [hasAllTableBackgroundBlur]="$safeNavigationMigration(state?.showModal)"
  [hasBackgroundBlur]="$safeNavigationMigration(state?.tableHasBlur)"
  [isToCloseAccordion]="isToCloseAccordion"
  [scrollEvent]="scrollEvent"
  [tableData]="tableData"
  tableName="table">
</app-table>

@if (hasPagination()) {
  <app-pagination (pageNumber)="changePage($event)"
    [collectionSize]="search.totalResults"
    [pageSize]="search.pageSize"
    [page]="search.pageNumber"
    data-cy="business-settings-list-pagination">
  </app-pagination>
}

<ng-template #accordionLineTemplate>
  <app-business-settings-tree
    (showBusinessSettingsReplicateModal)="openReplicateModal($event)"
    (showBusinessSettingsApplyModal)="openApplyModal($event)"
    (toggleTreeToEditModeEvent)="changeToEditMode()"
    (treeIsDiscardingEvent)="treeDiscardEvent($event)"
    (treeIsSavingEvent)="treeSaveEvent($event)"
    (treeSavedEvent)="onTreeSaved()"
    (treeChangeEvent)="treeWasChanged()"
    (updatePathAlertsBreadcrumbs)="updateLineBreadcrumbs($event)"
    [contextData]="accordionContext"
    [triggerSetPath]="triggerSetPath"
    [triggerEditEntity]="triggerEditEntity"
    [triggerUpdateBreadcrumbs]="triggerUpdateBreadcrumbs"
  class="accordion-body-content"></app-business-settings-tree>
</ng-template>

<!-- FIXME: this should belong to the new table component, to keep consistent behavior between the old table and the new one. -->
@if (isLoading) {
  <div class="spinner-container">
    <app-loading-spinner class="center-spinner"></app-loading-spinner>
  </div>
}

<ng-template #pathAlertsTemplate
  let-isSelected="isLineSelected"
  let-anchor="anchorReference"
  let-closeEvent="closeAccordion"
  let-openCallback="openAccordion"
  let-paths="paths"
  let-selectedSeparator="selectedSeparator"
  let-closeFullLineTooltip="closeFullLineTooltip">
  @if (isEmpty(paths)) {
    -
  } @else {
    <app-path-alerts [hasEditPathButton]="pathAlertsHasEditButton"
      [hasViewPathButton]="pathAlertsHasViewButton"
      [hasEditEntityButton]="pathAlertsHasEditButton"
      [hasViewEntityButton]="false"
      [paths]="paths"
      [forceCloseEvent]="closeEvent"
      [forceOpenLineCallback]="openCallback"
      [secondaryAnchorRef]="anchor"
      [selectedSeparator]="selectedSeparator"
      [alternateStyle]="!isSelected"
      (forceCloseFullLineTooltip)="closeFullLineTooltip()"
      (componentState)="updatePathAlertsComponentState($event)"
      (editPathClick)="editPath($event)"
      (viewPathClick)="viewPath($event)"
    (editEntityClick)="editEntity($event)"></app-path-alerts>
  }
  <ng-template #hasPaths>
    <app-path-alerts [hasEditPathButton]="pathAlertsHasEditButton"
      [hasViewPathButton]="pathAlertsHasViewButton"
      [hasEditEntityButton]="pathAlertsHasEditButton"
      [hasViewEntityButton]="false"
      [paths]="paths"
      [forceCloseEvent]="closeEvent"
      [forceOpenLineCallback]="openCallback"
      [secondaryAnchorRef]="anchor"
      [selectedSeparator]="selectedSeparator"
      [alternateStyle]="!isSelected"
      (forceCloseFullLineTooltip)="closeFullLineTooltip()"
      (componentState)="updatePathAlertsComponentState($event)"
      (editPathClick)="editPath($event)"
      (viewPathClick)="viewPath($event)"
    (editEntityClick)="editEntity($event)"></app-path-alerts>
  </ng-template>
</ng-template>
